export default function <T>(expr: any): T | undefined {
  return expr ? expr : undefined;
}
